import { Link } from '@tanstack/react-router';

import { ThemeToggle } from '@/components/theme/theme-toggle';
import { UserMenu } from '@/features/auth';

/**
 * The application header.
 *
 * Deliberately quiet: one hairline border, no fill of its own, no shadow. Atlas
 * exists to show someone else's prototype, and every pixel of chrome that draws
 * attention is a pixel arguing with the thing under review.
 */
export const AppHeader = () => (
  <header className="sticky top-0 z-30 border-b border-border bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70">
    <div className="mx-auto flex h-14 w-full max-w-7xl items-center gap-4 px-6">
      <Link
        to="/"
        className="text-sm font-semibold tracking-tight text-foreground"
      >
        Atlas
      </Link>
      <div className="ml-auto flex items-center gap-1">
        <UserMenu />
        <ThemeToggle />
      </div>
    </div>
  </header>
);
